import React from 'react';
import { motion } from 'framer-motion';
import { Brain, PenLine, Eye, Heart, Unlock, Footprints } from 'lucide-react';
export function AcronymSection() {
  const acronym = [{
    letter: 'R',
    title: 'Relajación',
    description: "Aprende a detener el ruido mental para escuchar la voz de Dios. Haz una pausa, respira profundamente y permite que tu mente y tu corazón encuentren un espacio de calma. Cuando aquietas el ruido exterior y disminuyes el ruido interior, puedes estar más presente y abrirte a la presencia de Dios.",
    icon: Brain
  }, {
    letter: 'E',
    title: 'Escritura',
    description: 'Aclara tus pensamientos, procesa tus emociones y fortalece tu crecimiento espiritual a través de la escritura guiada. Lo que escribes con intención, lo integras con profundidad.',
    icon: PenLine
  }, {
    letter: 'V',
    title: 'Visualización Bíblica',
    description: 'Entrena tu mente para enfocarse en las promesas de Dios — no en los problemas. Aprende a ver tu vida con los ojos de la fe, tal como lo hicieron los grandes hombres y mujeres de la Biblia.',
    icon: Eye
  }, {
    letter: 'E',
    title: 'Emoción Elevada',
    description: 'Cultiva gratitud, esperanza y confianza de manera intencional cada día. Porque la fe no es solo un pensamiento — es también un estado del corazón.',
    icon: Heart
  }, {
    letter: 'L',
    title: 'Liberación',
    description: 'Entrega tus cargas, tus miedos y tus preocupaciones a Dios de verdad. No solo en palabras — sino a través de un proceso que te ayuda a soltar lo que has estado cargando solo/a.',
    icon: Unlock
  }, {
    letter: 'A',
    title: 'Acción Inspirada',
    description: 'Da pasos concretos y alineados con tu fe. Porque la fe verdadera se mueve. Y Dios honra a quienes caminan hacia lo que Él prometió.',
    icon: Footprints
  }];
  return <section className="w-full bg-[#0A1535] py-20 px-6" style={{
    backgroundColor: "#F7F2E7",
    backgroundImage: "none"
  }} data-id="element-20" data-mp="2ag76y9yqsbev">
      <div className="max-w-5xl mx-auto" data-id="element-21" data-mp="2faba0i4vzzao">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-bold text-center text-white mb-16" style={{
        color: "#0A1535",
        fontSize: "36px"
      }} data-id="element-22" data-mp="2p3fkvijfquuj">
          ¿Qué significa R.E.V.E.L.A.?
        </motion.h2>

        <div className="space-y-8" data-id="element-23" data-mp="2a6y7ymvll85v">
          {acronym.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-gradient-to-r from-[#0B1A3A] to-[#0A1535] border border-[#E0B756]/20 rounded-lg p-8 hover:border-[#E0B756]/40 transition-colors" style={{
            backgroundColor: "#4A331A",
            backgroundImage: "none",
            borderColor: "#F2D78B"
          }} data-id="element-24" data-mp="267fnttblp143" data-mpi={index}>
                <div className="flex items-start gap-6" data-id="element-25" data-mp="3u5ggn9z9ywqb">
                  <div className="flex-shrink-0" data-id="element-26" data-mp="1yjr13jlicl3">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#C9A24B] to-[#E0B756] flex items-center justify-center" data-id="element-27" data-mp="21fokqrj6z90">
                      <span className="text-3xl font-bold text-[#0A1535]" data-id="element-28" data-mp="by0qh3897u8m">
                        {item.letter}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-29" data-mp="3fdy27gm2da92">
                    <div className="flex items-center gap-3 mb-3" data-id="element-30" data-mp="3fer2byqip1i8">
                      <Icon className="w-6 h-6 text-[#E0B756]" data-id="element-31" data-mp="3kcj6ps8cmg3b" />
                      <h3 className="text-2xl font-bold text-[#E0B756]" data-id="element-32" data-mp="3p4aq9it37ljy">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-gray-300 leading-relaxed whitespace-pre-line" style={{
                  color: "#F7F2E7"
                }} data-id="element-33" data-mp="2ron1fz4prfux">
                      {item.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}